export function destroySession() 
{
    sessionStorage.removeItem('accesstoken');
    sessionStorage.removeItem('uname');
    sessionStorage.removeItem('email');
    sessionStorage.removeItem('employeeid');
    sessionStorage.removeItem('departmentslug');
    sessionStorage.removeItem('department');
    sessionStorage.removeItem('position');
    sessionStorage.removeItem('role');
    sessionStorage.removeItem('name');
    sessionStorage.removeItem('img');
    sessionStorage.removeItem('outletcode');
    sessionStorage.removeItem('outletname');

    // dtr timesheet
    sessionStorage.removeItem('timesheetChild');
    sessionStorage.removeItem('timesheetChildSlug');
    sessionStorage.removeItem('timesheetGrandchild');
    sessionStorage.removeItem('timesheetGrandchildSlug');
    sessionStorage.removeItem('timesheetPayperiod');
    sessionStorage.removeItem('timesheetPayperiodId');
    sessionStorage.removeItem('timesheetEmployee');
    sessionStorage.removeItem('timesheetEmployeeUname');

    // report
    sessionStorage.removeItem('reportsYear');
    sessionStorage.removeItem('reportsPayperiod');
    sessionStorage.removeItem('reportsPayperiodId');
}